import { EStatusType } from 'src/types/enums/EStatusType'

import { ProgressIndicator } from './ProgressIndicator'

export const ExportFailed = (
  <ProgressIndicator status={EStatusType.failed}>Export failed</ProgressIndicator>
)
